export default __webpack_public_path__ + "static/media/logofooter.efc50b0e.svg";